skrilla.directive('searchCampaigns', function () {
    return {
        templateUrl: 'directives/campaigns/searchCampaigns.html',
        scope: {
            onClick:"="
        },
        controller: function ($scope,
                              searchService,
                              queryService,
                              paginationService,
                              cacheService,
                              promotionService) {
            $scope.key = "campaigns";
            $scope.reset = function () {
                $scope.query = {
                    providers: promotionService.getCampaignProviders(),
                    statuses: promotionService.getCampaignStatuses(),
                    limit: 20,
                };
            };
            $scope.reset();

            $scope.search = function () {
                paginationService.resetPage($scope.key);
                paginationService.pageQuery(getCampaigns, $scope.key);
            }

            var getCampaigns = function () {
                return searchService.get("campaigns" + queryService.getQueryString($scope.query, $scope.key)).then(function (response) {
                    $scope.campaigns = response.data.result;
                    cacheService.registerObject("campaignsTable", $scope.campaigns);
                    paginationService.setPage($scope.key, paginationService.buildPage(response));
                });
            }

            $scope.search()
        }
    };
});
